import { gql } from "@/gql";

// Configuration queries
export const GET_SALON_CONFIGURATIONS = gql(`
  query GetSalonConfigurations($salonId: ID!, $category: String) {
    getSalonConfigurations(salonId: $salonId, filters: { category: $category }) {
      configurations {
        key
        value
        dataType
        category
        createdAt
        updatedAt
      }
    }
  }
`);

export const GET_SALON_CONFIGURATIONS_BY_CATEGORY = gql(`
  query GetSalonConfigurationsByCategory($salonId: ID!) {
    getSalonConfigurationsByCategory(salonId: $salonId) {
      categories {
        category
        configurations {
          key
          value
          dataType
          category
          createdAt
          updatedAt
        }
      }
    }
  }
`);

export const GET_SALON_CONFIGURATION = gql(`
  query GetSalonConfiguration($salonId: ID!, $key: String!) {
    getSalonConfiguration(salonId: $salonId, key: $key) {
      key
      value
      dataType
      category
      createdAt
      updatedAt
    }
  }
`);

// Configuration mutations
export const UPDATE_SALON_CONFIGURATION = gql(`
  mutation UpdateSalonConfiguration($salonId: ID!, $input: UpdateSalonConfigurationInput!) {
    updateSalonConfiguration(salonId: $salonId, input: $input) {
      key
      value
      dataType
      category
      updatedAt
    }
  }
`);

export const UPDATE_SALON_CONFIGURATIONS = gql(`
  mutation UpdateSalonConfigurations($salonId: ID!, $input: UpdateSalonConfigurationsInput!) {
    updateSalonConfigurations(salonId: $salonId, input: $input) {
      key
      value
      dataType
      category
      updatedAt
    }
  }
`);

// Removed INITIALIZE_SALON_CONFIGURATIONS - no longer needed
// Configurations now have automatic default values

// Operating hours queries
export const GET_SALON_OPERATING_HOURS = gql(`
  query GetSalonOperatingHours($salonId: ID!) {
    getSalonOperatingHours(salonId: $salonId) {
      weeklyHours {
        dayOfWeek
        dayName
        isClosed
        timeSlots {
          id
          dayOfWeek
          startTime
          endTime
          slotOrder
          createdAt
          updatedAt
        }
      }
    }
  }
`);

export const GET_OPERATING_HOURS_FOR_DAY = gql(`
  query GetOperatingHoursForDay($salonId: ID!, $dayOfWeek: Float!) {
    getOperatingHoursForDay(salonId: $salonId, dayOfWeek: $dayOfWeek) {
      id
      dayOfWeek
      startTime
      endTime
      slotOrder
      createdAt
      updatedAt
    }
  }
`);

// Operating hours mutations
export const CREATE_OPERATING_HOURS = gql(`
  mutation CreateOperatingHours($salonId: ID!, $input: CreateOperatingHoursInput!) {
    createOperatingHours(salonId: $salonId, input: $input) {
      id
      dayOfWeek
      startTime
      endTime
      slotOrder
      createdAt
      updatedAt
    }
  }
`);

export const UPDATE_OPERATING_HOURS = gql(`
  mutation UpdateOperatingHours($salonId: ID!, $id: ID!, $input: UpdateOperatingHoursInput!) {
    updateOperatingHours(salonId: $salonId, id: $id, input: $input) {
      id
      dayOfWeek
      startTime
      endTime
      slotOrder
      updatedAt
    }
  }
`);

export const BULK_UPDATE_OPERATING_HOURS = gql(`
  mutation BulkUpdateOperatingHours($salonId: ID!, $input: BulkUpdateOperatingHoursInput!) {
    bulkUpdateOperatingHours(salonId: $salonId, input: $input) {
      id
      dayOfWeek
      startTime
      endTime
      slotOrder
      createdAt
      updatedAt
    }
  }
`);

export const INITIALIZE_DEFAULT_OPERATING_HOURS = gql(`
  mutation InitializeDefaultOperatingHours($salonId: ID!) {
    initializeDefaultOperatingHours(salonId: $salonId) {
      id
      dayOfWeek
      startTime
      endTime
      slotOrder
      createdAt
      updatedAt
    }
  }
`);

export const DELETE_OPERATING_HOURS = gql(`
  mutation DeleteOperatingHours($salonId: ID!, $id: ID!) {
    deleteOperatingHours(salonId: $salonId, id: $id)
  }
`);

export const IS_SALON_OPEN = gql(`
  query IsSalonOpen($salonId: ID!, $dateTime: DateTime!) {
    isSalonOpen(salonId: $salonId, dateTime: $dateTime)
  }
`);
